import {
  Frame,
  Page,
  Layout,
  TextField,
  TopBar,
  Card,
  FormLayout,
  SkeletonPage,
  Form,
  Button,
  TextContainer,
  SkeletonDisplayText,
  SkeletonBodyText,
  ProgressBar,
} from "@shopify/polaris";
import React, { useRef, useState, useCallback, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import CovidForm from "./FirstCare/CovidForm";
import CovidSubscriptionForm from "./FirstCare/CovidSubscriptionForm";
import image from "../images/firstcare-logo.jpeg";

export default function CustomForms() {
  const search = useLocation().search;
  const param_username = new URLSearchParams(search).get("username");
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);

  const handleUsernameChange = useCallback(
    (newValue) => setUsername(newValue),
    []
  );
  const handlePasswordChange = useCallback(
    (newValue) => setPassword(newValue),
    []
  );
  const toggleMobileNavigationActive = useCallback(
    () =>
      setMobileNavigationActive(
        (mobileNavigationActive) => !mobileNavigationActive
      ),
    []
  );
  const skipToContentRef = useRef(null);
  const loader = isSubmitting && <ProgressBar progress={40} size="small" />;
  const skipToContentTarget = (
    <a id="SkipToContentTarget" ref={skipToContentRef} tabIndex={-1} />
  );
  const actualLoginPage = (
    <Page title="" subtitle="COVID-19 Vaccine Consent Form">
      {loader}
      <Layout>
        <Layout.Section>
          <div class="logo-container">
            <img class="account-logo" src={image} />
          </div>
        </Layout.Section>
        {skipToContentTarget}
        {/* <Layout.AnnotatedSection
          title="CONSENT FORM –COVID-19 Vaccine"
          description="Version 3.0 – March 11 2021 "
        > */}
        <Layout.Section>
          <CovidSubscriptionForm isSubmitting={setIsSubmitting} />
        </Layout.Section>
        {/* </Layout></Layout.AnnotatedSection> */}
      </Layout>
    </Page>
  );
  const loadingPageMarkup = (
    <SkeletonPage>
      <Layout>
        <Layout.Section>
          <Card sectioned>
            <TextContainer>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText lines={9} />
            </TextContainer>
          </Card>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
  const pageMarkup = loading ? loadingPageMarkup : actualLoginPage;

  const topBarMarkup = (
    <TopBar
      showNavigationToggle
      onNavigationToggle={toggleMobileNavigationActive}
    />
  );
  return <Frame topBar={topBarMarkup}>{pageMarkup}</Frame>;
}
